module.exports = __webpack_public_path__ + "static/img/01.e492a34f.png";